import { Box, Button, Stack } from '@mui/material';
import { admissionStatus } from '../../../../../utils/admissionStatus';
import GlobalSelectFieldWithoutFormik from '../../../../../components/mui/GlobalSelectFieldWithoutFormik';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../../Hooks/useHandleApiResponse';
import { updateTerminationData } from '../../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';

export default function AdmissionStatusCRM({
  id,
  status,
  setOpenModalComponentName,
  dispatchParams,
  dispatchFn,
}) {
  const [select, setSelect] = useState({ id: status, label: '' });
  const {
    admissionRegisterNewTableDataLoading,
    loading:crdLoading,
  } = useSelector((store) => store.crd);
  const loading = admissionRegisterNewTableDataLoading || crdLoading;
  const dispatch = useDispatch();
  const apiHandler = useHandleApiResponse();

  const handleSubmit = () => {
    dispatch(updateTerminationData({ course_enrollment_status: select?.id, course_enrollment_id: id })).then((res) =>
      apiHandler(res, {
        onSuccess: () => {
          dispatch(dispatchFn(dispatchParams));
          setOpenModalComponentName(false);
        },
      }),
    );
  };
  return (
    <Stack gap={3}>
      <GlobalSelectFieldWithoutFormik
        data={admissionStatus}
        keys={{
          itemId: 'id',
          itemValue: 'label',
        }}
        label={'Status'}
        selectedDetails={select}
        setChange={setSelect}
        sx={{ width: '100%' }}
      />
      <Box
        display={'flex'}
        gap={2}
        sx={{
          alignSelf: 'flex-end',
        }}
      >
        <Button variant="outlined" onClick={() => setOpenModalComponentName(false)} disabled={loading}>
          cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? 'submitting' : 'submit'}
        </Button>
      </Box>
    </Stack>
  );
}
